const initState = {
    metrics: [],
    general_dashboard_data: [],
    department_dashboard_data: [],
    risk_dashboard_data: [],
    compliance_dashboard_data: [],
    complianceMetrics: [],
};

const dashboardReducer = (state = initState, action) => {

    switch (action.type) {

        case "RISK_DASHBOARD_DATA":
            return {
                ...state,
                risk_dashboard_data: action.risk_dashboard_data,
            };

        case "DEPARTMENT_DASHBOARD_DATA":
            return {
                ...state,
                department_dashboard_data: action.department_dashboard_data,
            };

        case "COMPLIANCE_DASHBOARD_DATA":
            return {
                ...state,
                compliance_dashboard_data: action.compliance_dashboard_data,
            };

        case "GENERAL_DASHBOARD_DATA":
            return {
                ...state,
                general_dashboard_data: action.general_dashboard_data,
            };

        case "METRICS":
            return {
                ...state,
                metrics: action.metrics,
            };
        
        case "COMPLIANCE_METRICS":
            return {
                ...state,
                complianceMetrics: action.metrics,
            };



        default:
            return state;
    }
};

export default dashboardReducer;
